import { render } from "./UserAuditLogs.vue?vue&type=template&id=e725548a&scoped=true"
import script from "./UserAuditLogs.vue?vue&type=script&lang=js"
export * from "./UserAuditLogs.vue?vue&type=script&lang=js"

import "./UserAuditLogs.vue?vue&type=style&index=0&id=e725548a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e725548a"]])

export default __exports__